// eslint-disable-next-line no-unused-vars
import React, { useEffect, useRef } from "react";
import effectsConfig from "../effects/effectsConfig"; // Steuerung der Effekte

const LightningEffect = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!effectsConfig.lightning) return; // ⚡ Falls deaktiviert, sofort beenden

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let width = (canvas.width = window.innerWidth);
    let height = (canvas.height = window.innerHeight);

    const drawLightning = (x, y, segments, spread) => {
      ctx.strokeStyle = "rgba(255, 255, 255, 0.9)";
      ctx.lineWidth = Math.random() * 3 + 1;
      ctx.beginPath();
      ctx.moveTo(x, y);

      for (let i = 0; i < segments; i++) {
        x += (Math.random() - 0.5) * spread;
        y += height / segments;
        ctx.lineTo(x, y);
      }

      ctx.stroke();

      // ⚡ Zusätzliche Verzweigungen (Nebenblitze)
      if (Math.random() > 0.5) {
        drawLightning(x, y, Math.floor(segments / 2), spread / 2);
      }
    };

    const animateLightning = () => {
      ctx.clearRect(0, 0, width, height);

      if (Math.random() > 0.95) { // ⚡ 5% Chance pro Frame für Blitze
        let numberOfStrikes = Math.floor(Math.random() * 3) + 1; // 1-3 Blitze auf einmal
        for (let i = 0; i < numberOfStrikes; i++) {
          const startX = Math.random() * width;
          const startY = 0;
          drawLightning(startX, startY, 12, 100);
        }

        // ⚡ Aufleuchteffekt für den Bildschirm
        canvas.style.opacity = "1";
        setTimeout(() => (canvas.style.opacity = "0.3"), 50); // Kurzes starkes Leuchten
        setTimeout(() => (canvas.style.opacity = "0"), 150); // Schnelles Abklingen
      }

      requestAnimationFrame(animateLightning);
    };

    animateLightning();

    const resize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
      ctx.clearRect(0, 0, width, height);
    };
  }, []);

  return effectsConfig.lightning ? (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 3, // Sicherstellen, dass Buttons klickbar bleiben
        opacity: 0, // Standardmäßig unsichtbar, leuchtet bei Blitzen auf
        transition: "opacity 0.1s ease-out",
      }}
    />
  ) : null;
};

export default LightningEffect;
